import React, { useEffect, useState } from "react";

export default function Text({
  content,
  isSingleStepScreen,
  singleScreenStep,
  id,
}) {
  const [aniPlay, setAniPlay] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setAniPlay((p) => {
        p = true;
        return p;
      });
    }, 500);
    return () => {
      setAniPlay((p) => {
        p = false;
        return p;
      });
    };
  }, [content.content]);
  return (
    <div
      style={{
        margin: content.component_margin
          ? content.component_margin
          : window.navigator.platform.includes("Win")
          ? content.windows_margin
          : "0",
      }}
    >
      {content.content.map((item, i) => {
        if (item.type === "next-pick") {
          const myAni = `0.5s linear ${i * 0.45}s forwards fadeIn`;
          return (
            <div
              key={`text-block${i}`}
              style={{
                opacity: "0",
                animation: aniPlay ? myAni : null,
                width: "60%",
                backgroundColor: "#825ef1",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: "13px 20px 10px",
                borderRadius: "30px",
                margin: item.margin ? item.margin : "0",
              }}
            >
              <p
                className={"body-text"}
                style={{
                  fontFamily: item.font ? item.font : "LG_Smart_Regular",

                  color: "white",
                  margin: "0px",
                  padding: "0px",
                  width: item.width ? item.width : "auto",
                  animation:
                    item.svg === "mr-ov" ? "0.5s fadeIn 0.3s forwards" : "none",
                  opacity: item.svg === "mr-ov" ? 0 : 1,
                }}
                dangerouslySetInnerHTML={{ __html: item.text }}
              ></p>
            </div>
          );
        } else {
          return (
            <p
              key={`text${i}`}
              className={
                item.type === "title"
                  ? "body-title"
                  : item.type === "alt-title"
                  ? "alt-title"
                  : id === "single"
                  ? "single-text body-text"
                  : "body-text"
              }
              style={{
                fontFamily: item.font ? item.font : "LG_Smart_Regular",
                fontSize: item.font_size,
                color: item.font_color,
                margin: item.margin ? item.margin : "0px",
                width: item.width ? item.width : "auto",
                lineHeight: item.line_height ? item.line_height : null,
                animation:
                  item.svg === "mr-ov" ? "0.5s fadeIn 0.3s forwards" : "none",
                opacity: item.svg === "mr-ov" ? 0 : 1,
                textIndent: item.indent ? "-8px" : null,
              }}
              dangerouslySetInnerHTML={{
                __html: isSingleStepScreen
                  ? item.text[singleScreenStep]
                  : item.text,
              }}
            ></p>
          );
        }
      })}
    </div>
  );
}
